module.exports = __webpack_public_path__ + "static/media/historicoSincronizarMobile.64945417.jpg";